import dayjs from 'dayjs';
import { config } from '../config';
import { ActCycleConfig, DialogContent } from '../types';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import { language, CustomException } from '@tencent/ppd-base-libs';
import { UtilsTypes } from '@tencent/wphk-act-base-types';
type LanguageTypeEnum = UtilsTypes.LanguageTypeEnum;
/** 当前语言 */
function curLanguage(): LanguageTypeEnum {
  return language.getLanguage() || 'zh-hk';
}

/** 根据语言获得文本数据 */
function getContentByLanguage(data: any) {
  return data[curLanguage()];
}

/** 格式化时间 */
function formatTime(time: string | Date) {
  if (!time) return time;
  return dayjs(time).format('YYYY/MM/DD HH:mm:ss');
}

/** 与默认配置整合成最终的配置 */
function formatConfig(innerConfig: ActCycleConfig): ActCycleConfig {
  const { startContent, startBtn, endContent, endBtn, businessStartTime, businessEndTime } = innerConfig;
  const {
    startContent: startContentConf,
    startBtn: startBtnConf,
    endContent: endContentConf,
    endBtn: endBtnConf,
  } = config;
  return {
    ...innerConfig,
    startContent: startContent || startContentConf,
    startBtn: startBtn || startBtnConf,
    endContent: endContent || endContentConf,
    endBtn: endBtn || endBtnConf,
    businessStartTime: formatTime(businessStartTime),
    businessEndTime: formatTime(businessEndTime),
  };
}

/** 获得弹窗显示内容 */
export function getDialogContent(innerConfig: ActCycleConfig): DialogContent | undefined {
  let dialogContent: DialogContent | undefined;

  /** 与默认配置整合成最终的配置 */
  const finalConfig = formatConfig(innerConfig);
  console.log('finalConfig: ', finalConfig);

  const {
    businessStartTime,
    businessEndTime,
    isShowStartDialog,
    isShowEndDialog,
    startContent,
    startBtn,
    endContent,
    endBtn,
  } = finalConfig;

  // 时间校验
  if (isShowStartDialog && businessStartTime && isShowEndDialog && businessEndTime) {
    if (dayjs(businessStartTime).isAfter(dayjs(businessEndTime))) {
      new CustomException(new Error('ActOverGetConfigTimeError'), 'ActOverGetConfigTimeError', '时间配置错误');
      return dialogContent;
    }
  }

  // 到达上架时间
  if (isShowStartDialog && businessStartTime && dayjs(getServerTime()).isBefore(dayjs(businessStartTime))) {
    dialogContent = {
      content: getContentByLanguage(startContent),
      btn: getContentByLanguage(startBtn),
      linkAdress: startBtn?.linkAdress,
    };
  }
  // 到达下架时间
  if (isShowEndDialog && businessEndTime && dayjs(getServerTime()).isAfter(dayjs(businessEndTime))) {
    dialogContent = {
      content: getContentByLanguage(endContent),
      btn: getContentByLanguage(endBtn),
      linkAdress: endBtn?.linkAdress,
    };
  }
  return dialogContent;
}
